export const catalog = [
  {
    code: "ST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Micropique Polo",
    colors: [
      "Black",
      "Blue Lake",
      "Deep Orange",
      "Deep Red",
      "Forest Green",
      "Gold",
      "Grey Concrete",
      "Iron Grey",
      "Kelly Green",
      "Lime Shock",
      "Maroon",
      "Purple",
      "Texas Orange",
      "Tropic Blue",
      "True Navy",
      "True Red",
      "True Royal",
      "Vegas Gold",
      "White",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 25.0,
      Medium: 25.0,
      Large: 25.0,
      XLarge: 25.0,
      "2XLarge": 26.0,
      "3XLarge": 27.0,
      "4XLarge": 28.0,
      "5XLarge": 29.0,
      "6XLarge": 30.0,
    },
  },
  {
    code: "LST650",
    name: "Sport-Tek® Polo Shirt",
    fullname: "Sport-Tek® Womens Micropique Polo",
    colors: [
      "Black",
      "Blue Lake",
      "Deep Orange",
      "Deep Red",
      "Forest Green",
      "Gold",
      "Grey Concrete",
      "Iron Grey",
      "Kelly Green",
      "Light Pink",
      "Lime Shock",
      "Maroon",
      "Pink Raspberry",
      "Purple",
      "Tropic Blue",
      "True Navy",
      "True Red",
      "True Royal",
      "White",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 25.0,
      Medium: 25.0,
      Large: 25.0,
      XLarge: 25.0,
      "2XLarge": 26.0,
      "3XLarge": 27.0,
      "4XLarge": 28.0,
    },
  },
  {
    code: "ST657",
    name: "Sport-Tek LS Polo",
    fullname: "Sport-Tek® Long Sleeve Micropique Polo",
    colors: [
      "Black",
      "Deep Red",
      "Forest Green",
      "Iron Grey",
      "Maroon",
      "True Navy",
      "True Red",
      "True Royal",
      "White",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 29.0,
      Medium: 29.0,
      Large: 29.0,
      XLarge: 29.0,
      "2XLarge": 30.0,
      "3XLarge": 31.0,
      "4XLarge": 32.0,
    },
  },
  {
    code: "L540LS",
    name: "Port Authority® Polo",
    fullname: "Port Authority Womens Long Sleeve Polo",
    colors: [
      "Black",
      "Bright Purple",
      "Carolina Blue",
      "Navy",
      "Red",
      "Royal",
      "Steel Grey",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 22.0,
      Medium: 22.0,
      Large: 22.0,
      XLarge: 22.0,
      "2XLarge": 23.0,
      "3XLarge": 24.0,
      "4XLarge": 24.0,
    },
  },
  {
    code: "J317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Core Soft Shell Jacket",
    colors: [
      "Battleship Grey",
      "Black",
      "Black Charcoal Heather",
      "Deep Smoke",
      "Dress Blue Navy",
      "Forest Green",
      "Maroon",
      "Navy Heather",
      "Pearl Grey Heather",
      "Rich Red",
      "True Royal",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 41.0,
      Medium: 41.0,
      Large: 41.0,
      XLarge: 41.0,
      "2XLarge": 42.0,
      "3XLarge": 43.0,
      "4XLarge": 44.0,
      "5XLarge": 45.0,
      "6XLarge": 46.0,
    },
  },
  {
    code: "L317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Ladies Core Soft Shell Jacket",
    colors: [
      "Battleship Grey",
      "Black",
      "Black Charcoal Heather",
      "Deep Smoke",
      "Dress Blue Navy",
      "Navy Heather",
      "Pearl Grey Heather",
      "Rich Red",
      "True Royal",
      "Very Berry",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 41.0,
      Medium: 41.0,
      Large: 41.0,
      XLarge: 41.0,
      "2XLarge": 42.0,
      "3XLarge": 43.0,
      "4XLarge": 44.0,
    },
  },
  {
    code: "K805",
    name: "Port Authority® Pullover",
    fullname: "Port Authority® Vertical Texture 1/4-Zip Pullover",
    colors: ["Black", "Iron Grey", "Regatta Blue", "True Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 32.0,
      Medium: 32.0,
      Large: 32.0,
      XLarge: 32.0,
      "2XLarge": 33.0,
      "3XLarge": 34.0,
      "4XLarge": 35.0,
    },
  },
  {
    code: "L805",
    name: "Port Authority® Pullover",
    fullname: "Port Authority® Women's Vertical Texture Full-Zip Jacket",
    colors: ["Black", "Iron Grey", "Regatta Blue", "True Navy"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 32.0,
      Medium: 32.0,
      Large: 32.0,
      XLarge: 32.0,
      "2XLarge": 33.0,
      "3XLarge": 34.0,
      "4XLarge": 35.0,
    },
  },
];
